import type { Guide } from '../types';

/**
 * S-26.10-02 — „Auta niedostępnego w TMS nie da się obsadzić” (decyzja z 19.10.2026). Do 26.10.2026 działało bez
 * przełącznika — przy wydaniu schowane za przełącznikiem, bo na produkcji niedostępność z TMS obsadzenia ręcznego nie
 * blokuje. Rekord pokazowy: DEMO 008 jest w kartotece niedostępne bez terminu (`seed-e2e.ts`).
 */
export const guide: Guide = {
  flagKey: 'unavailableBlocksAssignment',
  title: 'Auta niedostępnego w TMS nie da się obsadzić',
  whatItDoes:
    'Auto oznaczone w TMS jako niedostępne w dniu załadunku — bez terminu albo z terminem „niedostępny do” po dniu załadunku — nie daje się obsadzić żadną drogą: z rekomendacji, z wiersza banku, z karty zlecenia („Obsadź”, „Zmień pojazd”), z oferty na pojeździe ani z OneHub. Odmowa podaje powód i termin z TMS. Nie da się tego obejść, także Team Leaderowi. Bez tej zmiany niedostępność z TMS obsadzenia ręcznego nie blokuje (rekomendacje i tak pomijają takie auto z powodem).',
  audience: ['Team Leader', 'administrator', 'planista FTL'],
  presentationItems: ['S-26.10-02'],
  steps: [
    {
      route: '/user-offers/:orderId/show',
      record: {
        description: 'zlecenie do obsadzenia z wariantami',
        listPath: '/user-offers',
        listFilter: { forklift: 'hide', dzial: 'FTL' },
      },
      target: 'order-assign-car',
      title: 'Obsadzenie sprawdza dostępność z TMS',
      description:
        'Gdy wybrany pojazd jest w TMS niedostępny w dniu załadunku, „Obsadź” kończy się odmową z powodem i terminem z TMS, np. „pojazd oznaczony w TMS jako niedostępny w dniu załadunku (w naprawie, bez terminu)”. Auto trzeba najpierw przywrócić do dostępnych w TMS.',
      action: 'Wybierz pojazd z listy „Obsadź pojazdem” i kliknij „Obsadź”.',
      recorder: { account: 'master', demo: { kind: 'order', number: 'DEMO/2026/10/V01' } },
    },
  ],
};
